<template>
  <div class="Sobre">
    <div class="banner">
      <headNav :activeNav="'sobre'"></headNav>
      <div class="title">「 SOBRE NOSOTROS 」</div>
    </div>
    <div class="wrapper">
      <div class="bigContent">
        <div class="content clearfix">
          <div class="left">
            <div class="content_title">Perfil de la empresa</div>
            <p>
              LuckyPlata es una plataforma que ofrece préstamos en línea
              rápidos, accesibles y seguros. Regístrate en segundos, aplica para
              un préstamo y recibe tu efectivo en minutos.Vemos el mundo
              diferente. Estamos motivados por una creencia fundamental en las
              personas, y trabajamos juntos para demostrar su potencial.
              Asumimos riesgos que otros no tomarían para poner más poder en las
              manos de nuestros clientes.
            </p>
          </div>
          <div class="right">
            <img src="@/assets/image/about_img.png" alt="" />
          </div>
        </div>
      </div>
      <div class="p6">
        <div style="text-align: center">
          <div class="title">Contáctanos</div>
          <p class="item-title" style="margin-bottom: 50px">
            Si necesita cualquier ayuda, favor de enviarnos un correo o llamar a
            nuestro teléfono de atención al cliente.
          </p>
          <ul>
            <li>
              <img src="../assets/image/dianhua.png" alt="" />
              <div>
                <p style="color: #666666; margin-bottom: 7px">
                  Atención al Cliente:
                </p>
                <p style="color: #333333">+57 3042345034</p>
              </div>
            </li>
            <li>
              <img src="../assets/image/whats_app.png" alt="" />
              <div>
                <p style="color: #666666; margin-bottom: 7px">WhatsApp:</p>
                <p style="color: #333333">+57 3209669841</p>
              </div>
            </li>
            <li>
              <img src="../assets/image/ico_2.png" alt="" />
              <div>
                <p style="color: #666666; margin-bottom: 7px">Email:</p>
                <p style="color: #333333">servicio@luckyplata.co</p>
              </div>
            </li>
            <li>
              <img src="../assets/image/tm_ico.png" alt="" />
              <div>
                <p style="color: #666666; margin-bottom: 7px">
                  Horario de Atención:
                </p>
                <p style="color: #333333">
                  L-V 8:00 a 17:00<br />S 8:00 a 12:00
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <footPage></footPage>
  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import footPage from "@/components/foot.vue";

import "../components/scss/sobre.scss";

export default {
  name: "Sobre",
  components: { headNav, footPage },
  data () {
    return {};
  },
};
</script>

<style scoped></style>